import React from "react";

const ContactPage = () => {
  return (
    <div>
      <h1>
        <span class="orangeFixed">Contact - RedBull Team</span>
      </h1>
      <div className="container">
        <p>
          We'd love to hear from you! Feel free to reach out to our team members
          by email
        </p>
        <div className="contact-info">
          <h3>
            <span class="orangeFixed">Team Members:</span>
          </h3>
          <p>Jade - jadefauvelle@hotmail.ca</p>
          <p>Parker - parkerthestone@gmail.com</p>
          <p>Josh - joshua.magnan@gmail.com</p>
          <br />
          <p>We are 3 second year CS students</p>
          <h4>
            <span class="orangeFixed">Heritage College, Gatineau</span>
          </h4>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
